import { useLocation } from "react-router-dom";
import React from "react";

export const useQuery = <T>(key: string): string | T => {
    const { search } = useLocation();

    const query = React.useMemo(() => new URLSearchParams(search), [search]);
    return query.get(key) || ""
}
